import type { JssState } from '@core/jss-routing';
import type { Action } from '@ngrx/store';

/* eslint-disable max-classes-per-file */

export enum KnowledgeBaseTypes {
  INIT = '[KnowledgeBase] Init',
  ROUTE_CHANGE = '[KnowledgeBase] Route change',
}

export class KnowledgeBaseInitAction implements Action {
  readonly type = KnowledgeBaseTypes.INIT;
}
export class KnowledgeBaseRouteChange implements Action {
  readonly type = KnowledgeBaseTypes.ROUTE_CHANGE;
  constructor(public readonly payload: JssState) {}
}

export type KnowledgeBaseActionsUnion =
  | KnowledgeBaseInitAction
  | KnowledgeBaseRouteChange;
